import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import styles from './AdminDashboardPage.module.scss';

class AdminDashboardPage extends Component<RouteComponentProps> {
  render() {
    const { history: { push } } = this.props;

    return (
      <div className={styles.container}>
        <h2>Administration</h2>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
          <button onClick={() => push('/administration/invite-user')}>
            Create organization
          </button>
          <button onClick={() => push('/administration/sso-allowed-emails')}>
            Allowed SSO emails
          </button>
        </div>
      </div>
    );
  }
}

export default AdminDashboardPage;
